"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _context = _interopRequireDefault(require("../context"));

var _subscribeHelper = require("../helpers/subscribe-helper");

var LocalizedTypography = function LocalizedTypography(_ref) {
  var message = _ref.message,
      classNameProp = _ref.className,
      values = _ref.values,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["message", "className", "values"]);

  var _useContext = (0, _react.useContext)(_context["default"]),
      _localizeDebug = _useContext._localizeDebug,
      localize = _useContext.localize;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      postMessageHandler = _useState2[0],
      setPostMessageHandler = _useState2[1];

  var localized = message; // OnClick only used during inline editing checks if you clicks inside the green box

  var onClick = function onClick(proxy) {
    proxy.preventDefault();
    proxy.stopPropagation();
    var localized = localize(message, values);
    window.localizationPopup.open(message, localized);
    (0, _subscribeHelper.subscribeToTranslationChange)(message, null, postMessageHandler, setPostMessageHandler);
  };

  if (typeof localize === 'function') {
    localized = localize(message, values);

    if ((0, _typeof2["default"])(localized) === 'object') {
      var index = 0;
      localized = localized.map(function (i) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: index++
        }, i);
      });
    }
  }

  var className = (0, _classnames["default"])('', {
    'localize-debug-mode-target': _localizeDebug
  }, classNameProp);

  if (_localizeDebug) {
    rest['data-original-message'] = message;
    return /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
      className: className
    }, rest), /*#__PURE__*/_react["default"].createElement("div", {
      className: "localize-debug-mode-click-area",
      onClick: onClick
    }), localized);
  }

  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    className: className
  }, rest), localized);
};

LocalizedTypography.propTypes = {
  message: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  values: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object])
};
var _default = LocalizedTypography;
exports["default"] = _default;